export const blogApiURL = 'https://h6x2a8coqj.execute-api.ap-southeast-2.amazonaws.com';

export const contactApiURL = 'https://ej22ayi51d.execute-api.ap-southeast-2.amazonaws.com';